import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "inherit",
      "fill-rule": "evenodd",
      d: "m9.885 8 5.724 5.724a1.33 1.33 0 0 1 0 1.885 1.33 1.33 0 0 1-1.885 0L8 9.885 2.276 15.61A1.332 1.332 0 0 1 0 14.666c0-.341.13-.682.39-.942L6.116 8 .39 2.276a1.33 1.33 0 0 1 0-1.885 1.33 1.33 0 0 1 1.885 0L8 6.115 13.724.39a1.33 1.33 0 0 1 1.885 0 1.33 1.33 0 0 1 0 1.885z"
    }, null, -1)
  ]))]))
}
export default { render: render }